export interface Column {
  title: string;
  name: string;
  type: 'url' | 'newSelect' | 'select' | 'string' | 'number' | 'date' | 'selected' | 'boolean' | 'editableColumns' | 'button';
  editable?: boolean;
  checkAll?: boolean;
  class?: string;
  visible?: boolean;
  toggleValue?: () => boolean;
  expand?: string;
  mandatory?: boolean;
  placeholderHidden?: boolean;
  sort?: boolean | ((a: any, b: any, allData?: any[]) => number);
  listing?: boolean;
  align?: string;
  sortServer?: boolean;
  sortServerType?: SortServerType;
  onlyExport?: boolean;
  value(element: any, element2?: any): any;
}

/**
 * Sort server type
 */
export enum SortServerType {
  DESC = 'desc',
  ASC = 'asc'
}
/**
 * Modelo de configuración de la tabla
 */
export interface DataTable {
  /**
   *
   * TODO: Placeholder del filtro
   * para la busqueda de cada opción en la tabla por una cadena de texto
   */
  searchText?: string;
  /**
   * Tipo boolean para hacer busqueda en predictiva desde un servicio externo
   */
  searchTextService?: boolean;
  /**
   * TODO: Nombre del botón
   * Descripción del botón principal de la tabla
   */
  addText?: string;
  secondaryButtonText?: string;
  secondaryButtonIcon?: string;
  /**
   * TODO: nombre del icono del botón
   * Icono a mostrar para el botón de la tabla
   */
  iconAddText?: string;
  /**
   * TODO: bandera para permitir deshabilitar botón del header de la tabla
   * Si esta habilitado, al marcar un checkbox se deshabilita el botón
   */
  isButtonDisabled?: boolean;
  /**
   * TODO: Permite exportar
   * Exporta los datos de la tabla
   */
  export?: boolean;
  /**
   * TODO: Para visualizar el botón adicional a exportar
   * Exporta datos adicionales de la tabla
   */
  exportAdditional?: boolean;
  /**
   * TODO: Permite exportar toda la data sin considerar la paginación aplica solo cuando el
   * campo @import export esta en true
   * Exporta todos los datos de la tabla
   */
  exportAllData?: boolean;
  /**
   * TODO: Nombre del archivo que se va descargar .xls
   * Nombre del archivo a descargar
   */
  exportFile?: string;
  /**
   * TODO: Nombre del botón exportar adicional  xls
   * Nombre de la opcion adicional a descargar
   */
  exportNameAdditional?: string;
  /**
   * TODO: Nombre del archivo adicional que se va descargar  .xls
   * Nombre del archivo adicional a descargar
   */
  exportFileAdditional?: string;
  /**
   * TODO: Permite expandir
   * Expande la fila de la tabla para mostrar una sub columna
   */
  expandable?: boolean;
  /**
   * TODO: Permite filtrar por selected
   * Controla los datos de la tabla con las opciones del selected
   */
  filter?: boolean;
  /**
   * TODO: Valor inicial del filtro
   * Opción del control selected
   */
  filterDefault?: string;
  /**
   *  Permite seleccionar cada casilla de verificación de la tabla
   */
  checkbox?: boolean;
  /**
   *  Descripción dinámica de todas las columnas de la tabla
   */
  columns?: Column[];
  /**
   * TODO: Condición al seleccionar check all
   ** Revisar
   */
  checkboxHeader?: boolean;
  /**
   * TODO: oculta el checkbox del header de la tabla
   ** Bandera para mostrar u ocultar checkbox
   */
  checkboxRow?: boolean;
  /**
   * TODO: oculta el checkbox de las filas de la tabla
   * Bandera para mostrar u ocultar checkbox de las filas
   */
  disabled?: boolean;
  /**
   * TODO: Agrega una columna condicional
   * Inserta una columna en column[]
   */
  partialField?: string;
  /**
   * TODO: falta ;(
   * falta ;(
   */
  table?: boolean;
  /**
   * TODO: Reordena las prioridades de columna
   * Muestra las columnas prioritarias, filtra y ordena la posición
   */
  alterColumns?: boolean;
  /**
   * TODO: Detalle de la fila
   * Genera una nueva tabla con los detalles de la fila en el mismo módule
   */
  subTable?: {
    description?: string;
    columns?: Column[];
  };
  /**
   * TODO: Lista de iconos
   * Muestra los iconos al habilitar la casilla de la fila
   */
  iconsOfActions?: IconsOfActions[];
  /**
   * Descripción de una tabla vacía
   */
  show?: string;
  /**
   * TODO: Observación
   * Tiene la misma funcionalidad que el addText ;(
   */
  dialogHability?: boolean;
  /**
   * TODO: bandera para mostrar botón que abre modal
   *
   */
  showIcon?: string;
  /**
   * TODO: Ordenar columnas
   * Ordena cada columna de Angular material
   */
  sort?: boolean;
  /**
   * Tipo booleano para insertar paginasión a la tabla
   */
  paginator?: boolean;
  /**
  * TODO: Paginación de la tabla por backend
  *
  */
  paginatorAllData?: boolean;
  /**
  * TODO: Paginación de la tabla por frontend
  *
  */
  checkboxIds?: string;
  /**
   * TODO: Funcion para habilitar checkbox de cada registro
   * @param item
   * funcion que nos pemitira habilitar y deshabilitar de acuerdo a cada
   * logica de nuestro modulos
   */
  selectedRow?: boolean;
  /**
   * Variable para definir la moneda del usuario logeado
   */
  currency?: string;
  /**
   * TODO: Funcion que retorna un booleano para habilitar los checkboxs de un fila
   * @param item Fila actual
   * @param selectionItems
   * @param selection
   */
  hasDisabledCheckBoxItem?(item?: any, selectionItems?: any, selection?: any): boolean;
  /**
   * TODO: Funcion para habilitar toggle de cada fila
   * @param item
   * funcion que nos pemitira habilitar y deshabilitar toggle de acuerdo a cada
   * logica por modulos
   */
  toggleValidation?(row: any): boolean;
  /**
  * TODO: Funcion para permitir expandir la fila de la tabla
  * @param item
  * permitira expandir la tabla si al menos tiene un item que mostrar
  * logica por modulo
  */
  expandingValidation?(row: any): boolean;

  /**
   * TODO: Asignar una clase segun cada modulo
   * @param item
   * Valida alguna propiedad de la fila y retorna una clase
   * logica de nuestro modulos
   */
  classValidation?(item: any): any;
  /**
   * TODO: Funcion que evalua la propiedad disabled de un input text en la tabla
   */
  hasDisabledInput?(item: any): boolean;
}

export interface IconsOfActions {
  /**
   * TODO: Nombre de icono
   *
   */
  icon?: string;
  /**
   * TODO: Tooltip
   * Texto que se vera en el tooltip de cada icono
   */
  tooltip?: string;
  /**
   * TODO: Typo de icons
   * Valor que nos permite distinguir de otros iconos ya que se puede dar el caso de tener los mismos
   * iconos por el tema de las sub-tablas
   */
  type?: any;
  /**
   * TODO: Funcion para visualizar los boton de la parte superior de la tabla
   * condicion que dependera de cada modulo
   * <true?: Que el icono es visible, false?: si el icono no es visible>
   */
  hasVisibleCondition?(element: any): boolean;
}

